import { dateFormat } from '@app/constants'

import { getFormattedDate } from '@app/utils/date'

import type { InternalTasksItemCommentsDto } from '@app/api/routes/internalTasks/dtos'
import type { ResponseDto } from '@app/api/dtos'
import type { CommentsTabData } from '@app/components/ActivityFeed/tabs/types'

export const getInternalTasksItemCommentsDataFromResponse = (
  response?: ResponseDto<InternalTasksItemCommentsDto>
): CommentsTabData[] | undefined => {
  if (!response) return

  const rawData: InternalTasksItemCommentsDto[] | undefined = response.results

  if (!rawData) return

  return rawData.map(dto => ({
    id: dto.id,
    message: dto.message,
    author: dto.author,
    createdAt: getFormattedDate(dto.createdAt, dateFormat.DD_MM_YYYY_HH_mm)
  }))
}
